import React from 'react';
import { styled } from 'linaria/react';
import { Link } from 'react-router-dom';
import { SearchField } from '../Search';
import CartButton from '../../../Cart/CartButton';
import { Inner, PagePadding } from '../../MaxWidth';
import TopNav from '../Util/TopNav';
import Logo from '../Logo';
import { FavouriteCount } from '../../../ProductList/FavouriteCount';
import { theme } from '../../../Theming/Theming';

export const headerTransitions = `
  transition: all 0.5s ease;
`;

const DesktopHeaderWrapper = styled('div')`
  height: ${theme.desktopHeader.height.lg + 'px'};
  ${headerTransitions}
  padding: 0 0;
  ${theme.only.md} {
    height: ${theme.desktopHeader.height.md + 'px'};
  }
  &[data-scrolling='true'] {
    height: ${theme.desktopHeader.height.scroll + 'px'};
    box-shadow: 0px 1px 5px #0000001c;
  }
  background: ${theme.desktopHeader.background};
  .page-padding,
  .inner {
    height: 100%;
  }
  .inner {
    display: flex;
    align-items: center;
  }

  .top-nav-list {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    > li {
      padding: 0 0.6rem;
      display: flex;
      height: 100%;
      align-items: center;
      &:last-child {
        padding-right: 0.6rem !important;
      }
    }
  }
  .header-icon {
    font-size: 22px;
    color: ${theme.desktopHeader.color};
  }
  .header-button {
    position: relative;
    display: flex;
  }
`;

const StoreLogo = styled('div')`
  transition: height 0.4s ease;
  width: 180px;
  ${theme.above.xxl} {
    width: 220px;
  }
  transition: width 0.4s ease;
  //margin: 0 auto;
  ${theme.only.md} {
    max-height: ${theme.desktopHeader.height.md - 20 + 'px'};
  }
  text-align: center;
  text-decoration: none;
  color: inherit;
  a {
    text-decoration: none;
    color: inherit;
    > img,
    > div,
    > svg {
      transition: max-height 0.4s ease;
      max-width: 100%;
      max-height: ${theme.desktopHeader.height.lg - 20 + 'px'};
      ${theme.only.md} {
        max-height: ${theme.desktopHeader.height.md - 20 + 'px'};
      }
    }
  }
  &[data-scrolling='true'] {
    max-height: ${theme.desktopHeader.height.scroll + 'px'};
    a {
      > img,
      > div,
      > svg,
      > .scroll-logo {
        max-height: ${theme.desktopHeader.height.scroll - 20 + 'px'};
      }
    }
    .scroll-logo {
    }
  }
`;

export const HeaderButton = styled('button')`
  display: flex;
`;

export const HeaderIconText = styled('span')`
  display: none;
  ${theme.below.lg} {
    display: none;
  }
`;

const SearchFieldWrapper = styled('div')`
  position: relative;
  .masking {
    position: absolute;
    width: 23px;
    height: 50px;
    left: -300px;
    top: -22px;
    background: ${theme.desktopHeader.background};
    background: linear-gradient(
      90deg,
      ${theme.desktopHeader.background} 0%,
      ${theme.desktopHeader.background}00 0%,
      ${theme.desktopHeader.background} 50%,
      ${theme.desktopHeader.background} 100%
    );
  }
  .search-wrapper {
    background: ${theme.colors.primaryLight};
    border-radius: 20px;
    position: absolute;
    width: 280px;
    top: -22px;
    right: 0;
    padding-right: 0;
    z-index: 1;
  }
  .search-field {
    padding-left: 1rem;
  }
  input {
    background: ${theme.colors.primaryLight};
    color: white;
  }
  .submit-search {
    right: 1rem;
    svg {
      color: white;
    }
  }
  .close-search {
    display: none;
  }
`;

const DesktopHeader = ({ scrolling, searchOpen, setSearch, children }) => {
  return (
    <DesktopHeaderWrapper data-scrolling={scrolling}>
      <PagePadding>
        <Inner className="inner">
          <StoreLogo data-scrolling={scrolling}>
            <Link to="/">
              <Logo type="desktop" />
            </Link>
          </StoreLogo>
          {children}
          <TopNav right>
            <SearchFieldWrapper data-scrolling={scrolling}>
              <div className="masking" />
              <SearchField
                onCancel={() => {
                  setSearch(false);
                }}
                setSearch={setSearch}
                searchOpen={searchOpen}
                scrolling={scrolling}
              />
            </SearchFieldWrapper>
            <FavouriteCount className="header-button" />
            <CartButton className="header-button" />
          </TopNav>
        </Inner>
      </PagePadding>
    </DesktopHeaderWrapper>
  );
};

export default DesktopHeader;
